/* ar-ppb.js — shared behavior for ar-ppb-* sections */
(function () {
  if (window.__arPpbInit) return;
  window.__arPpbInit = true;

  // Scroll reveal
  if (!window.matchMedia('(prefers-reduced-motion:reduce)').matches && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.arppb-rev').forEach(function (el) { io.observe(el); });

    // Re-observe any added later
    var mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.classList && n.classList.contains('arppb-rev')) io.observe(n);
          n.querySelectorAll && n.querySelectorAll('.arppb-rev').forEach(function (el) { io.observe(el); });
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  // Sticky CTA (if present)
  function initSticky() {
    var st = document.querySelector('.arppb-sticky');
    if (!st) return;
    var shown = false;
    function onS() {
      var y = window.scrollY || window.pageYOffset;
      var h = window.innerHeight;
      var s = y > h * 0.6;
      if (s !== shown) {
        shown = s;
        st.classList.toggle('arppb-sticky--visible', s);
        st.setAttribute('aria-hidden', s ? 'false' : 'true');
      }
    }
    window.addEventListener('scroll', onS, { passive: true });
    onS();
  }
  if (document.readyState !== 'loading') initSticky();
  else document.addEventListener('DOMContentLoaded', initSticky);
})();
